import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ValidatorFn, Validators } from '@angular/forms';
import {
	DropdownControlComponent,
	DropdownOption,
} from '../../../controls/standard/dropdown-control/dropdown-control.component';
import { BaseFieldComponent } from '../base-field/base-field.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { EngineService } from '../../../../services/engine.service';

@Component({
	selector: 'app-engine-dropdown-field',
	standalone: true,
	imports: [AppModule, ZorroModule, ThirdPartyModule, AngularModule, DropdownControlComponent],
	templateUrl: './engine-dropdown-field.html',
	styleUrl: './engine-dropdown-field.scss',
})
export class EngineDropdownField extends BaseFieldComponent implements OnInit, OnDestroy {
	@Input('multiple') public multiple: boolean = false;

	public options: DropdownOption[] = [];

	public static override validators: ValidatorFn[] = [Validators.required];

	constructor(private engineService: EngineService) {
		super();
	}

	ngOnInit(): void {
		this.engineService.getEngines$().then(engines => {
			this.options = engines.map(engine => ({
				value: engine.name,
				label: engine.name,
			}));
		});
	}

	ngOnDestroy(): void {}
}
